import { Competition as SrvgCompetition } from "@gaming/srvg-classes-core";

export class Competition extends SrvgCompetition {
    numberOfGroups: number;
    programCode: string;
    competitionTypeId: number;

    constructor( id:number, nr:number, start:number, end:number, name:string, numberOfGroups:number, programCode: string, competitionTypeId: number ) {
        super( id, nr, start, end, name );
        this.numberOfGroups = numberOfGroups;
        this.programCode = programCode;
        this.competitionTypeId = competitionTypeId;
    }
}